import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useMetricInfo } from 'modules/billing/hooks/useMetricInfo';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { AnalyticCard } from '../AnalyticCard';
import { AnalyticTileProps } from '../AnalyticTile';
import { ProjectBreakdownLink } from '../ProjectBreakdownLink';
import { CATALOG_CARD_IDS, CATALOG_CARD_TEXT, CATALOG_METRIC_NAMES } from './constants';

const {
  cardTitle,
  catalogCollectionDescription,
  catalogCollectionName,
  catalogLookupDescription,
  catalogLookupName,
  productRecommendationDescription,
  productRecommendationName,
  projectBreakdownUrl,
} = CATALOG_CARD_TEXT;

export const CatalogUsageCard = () => {
  const isProductRecommendationsEnabled = useFeatureFlag('ProductRecommendations');
  const { isLoading } = useQueryContext();

  const [catalogLookupInfo, catalogCollectionInfo, productRecommendationInfo] =
    useMetricInfo(CATALOG_METRIC_NAMES);

  const catalogMetrics: AnalyticTileProps[] = [
    {
      metricDescription: catalogLookupDescription,
      metricName: catalogLookupName,
      metricValue: catalogLookupInfo.value,
      timePeriod: catalogLookupInfo.dateRangeText,
    },
    {
      metricDescription: catalogCollectionDescription,
      metricName: catalogCollectionName,
      metricValue: catalogCollectionInfo.value,
      timePeriod: catalogCollectionInfo.dateRangeText,
    },
  ];

  const productRecommendationMetric = {
    metricDescription: productRecommendationDescription,
    metricName: productRecommendationName,
    metricValue: productRecommendationInfo.value,
    timePeriod: productRecommendationInfo.dateRangeText,
  };

  return (
    <AnalyticCard
      CardAction={<ProjectBreakdownLink to={projectBreakdownUrl} />}
      data-test={CATALOG_CARD_IDS.cardId}
      isLoading={isLoading}
      metrics={
        isProductRecommendationsEnabled
          ? [...catalogMetrics, productRecommendationMetric]
          : catalogMetrics
      }
      title={cardTitle}
    />
  );
};
